var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_29198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33794 1.28979L13.8084 0.5L21.2789 1.28979L27.0626 9.05378L13.8084 24.4881L0.554321 9.05378L6.33794 1.28979Z",
    fill: "#FDB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92291 9.05379L13.8085 24.4881L0.554321 9.05379H5.92291Z",
    fill: "#EA6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6939 9.05379L13.8084 24.4881L27.0625 9.05379H21.6939Z",
    fill: "#EA6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92285 9.05379H21.694L13.8084 24.4881L5.92285 9.05379Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8084 0.5L6.33786 1.28978L5.92285 9.05377L13.8084 0.5Z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8084 0.5L21.279 1.28978L21.694 9.05377L13.8084 0.5Z",
    fill: "#FDD231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0626 9.05378L21.279 1.28978L21.694 9.05378H27.0626Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.554321 9.05378L6.33792 1.28978L5.92291 9.05378H0.554321Z",
    fill: "#FDAD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8084 0.5L5.92285 9.05377H21.694L13.8084 0.5Z",
    fill: "#FEEEB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_29198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5618,
    height: 24,
    fill: "white",
    transform: "translate(0.554321 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.13fd5c110794ac08f8564d9b3436699a.svg";
export { ForwardRef as ReactComponent };